import { useLazyQuery } from '@apollo/client/react';
import { useEffect, useMemo } from 'react';

import { GetMedixsEventsDocument } from '~/graphql/generated/graphql';
type Props = {
  medixsPatientId: string;
};

export const useFetchMedixsEvents = (props: Props) => {
  const { medixsPatientId } = props;
  const [getMedixsEvents, { called, loading, data }] = useLazyQuery(GetMedixsEventsDocument, {
    fetchPolicy: 'network-only',
  });

  const medixsEvents = useMemo(() => {
    const node = data?.node;
    return node?.__typename === 'MedixsPatient' ? (node.medixsEvents?.nodes ?? []) : [];
  }, [data]);

  useEffect(() => {
    if (called) return;

    getMedixsEvents({ variables: { id: medixsPatientId } });
  }, [getMedixsEvents, called, medixsPatientId]);

  return {
    loading: !called || loading,
    medixsEvents,
  };
};
